var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 9.16675H38.5V38.5001H5.5V9.16675Z",
    stroke: "url(#paint0_linear_605_4303)",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 16.5001H5.5",
    stroke: "url(#paint1_linear_605_4303)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 20.1667V23.8334M20.1667 20.1667V23.8334M25.6667 20.1667V23.8334M32.0833 20.1667V23.8334",
    stroke: "url(#paint2_linear_605_4303)",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 25.6667V29.3334M20.1667 25.6667V29.3334M25.6667 25.6667V29.3334M32.0833 25.6667V29.3334",
    stroke: "url(#paint3_linear_605_4303)",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 31.1667V34.8334M20.1667 31.1667V34.8334M25.6667 31.1667V34.8334M32.0833 31.1667V34.8334",
    stroke: "url(#paint4_linear_605_4303)",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 9.16667V5.5",
    stroke: "url(#paint5_linear_605_4303)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1663 9.16667V5.5",
    stroke: "url(#paint6_linear_605_4303)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_605_4303",
    x1: 5.5,
    y1: 29.0001,
    x2: 35.5594,
    y2: 11.3308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E9FDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F749F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_605_4303",
    x1: 5.5,
    y1: 17.1459,
    x2: 7.24987,
    y2: 8.91715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E9FDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F749F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_605_4303",
    x1: 13.75,
    y1: 22.6459,
    x2: 16.6215,
    y2: 15.1442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E9FDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F749F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_605_4303",
    x1: 13.75,
    y1: 28.1459,
    x2: 16.6215,
    y2: 20.6442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E9FDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F749F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_605_4303",
    x1: 13.75,
    y1: 33.6459,
    x2: 16.6215,
    y2: 26.1442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E9FDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F749F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_605_4303",
    x1: 11,
    y1: 7.97917,
    x2: 14.5302,
    y2: 6.13464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E9FDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F749F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_605_4303",
    x1: 29.333,
    y1: 7.97917,
    x2: 32.8632,
    y2: 6.13464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E9FDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F749F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.86ce3588bd076de47351b2092e1005df.svg";
export { ForwardRef as ReactComponent };